/**
 * @fileoverview Loader Components
 * 
 * This file contains loading spinner components used throughout the Heidrick & Struggles
 * Leader Profile application to indicate loading states during asynchronous operations.
 * 
 * It exports two loader components:
 * 1. Default Loader - Generic loading spinner for general use
 * 2. AssessmentsLoader - Specialized loader with specific positioning for assessments page
 */

import { Spinner } from "@eightfold.ai/octuple";
import React from "react";

/**
 * Default Loader Component
 * 
 * Renders a centered spinner for indicating loading states throughout the application.
 * Used as a general-purpose loading indicator when data is being fetched or processed.
 * 
 * @returns {JSX.Element} The rendered spinner component with wrapper
 */
const Loader = () => {
  return (
    <div className="loaderWrap">
      <Spinner
        classNames="my-spinner-class"
        size="64px"
      />
    </div>
  );
}

/**
 * Assessments Loader Component
 * 
 * Specialized loader component for the assessments section with custom positioning.
 * Uses relative positioning to adjust the spinner's vertical placement (115px from bottom).
 * 
 * @returns {JSX.Element} The rendered spinner component with customized positioning
 */
export const AssessmentsLoader = () => {
  return (
    <div className="loaderWrap" style={{ position: 'relative', bottom: '115px' }}>
      <Spinner
        classNames="my-spinner-class"
        size="64px"
      />
    </div>
  );
}

export default Loader;